import React, {Component} from 'react';
import debounce from 'lodash/debounce';
import { PropTypes, array, bool } from 'prop-types';
import { Field, FormSection, reduxForm } from 'redux-form'
import Address from '../../shared/components/form-section/Address';
import Contact from '../../shared/components/form-section/Contact';
import Shipping from '../../shared/components/form-section/Shipping';
import Tabs from '../../shared/components/tabs/Tabs';

import { Form, Input, Button, Card, CardColumns, CardTitle, CardBody, CardHeader, Col, Row, Label } from 'reactstrap';
import Snackbar from '@material-ui/core/Snackbar';

import SimpleLineIcon from 'react-simple-line-icons';
import { renderField, renderTextareaField, renderSelectField, renderCheckbox, renderDateField, renderMembers, renderCombobox, renderMultiselect } from '../../shared/components/form-field/ReduxFormFields';
import { UploadFile } from '../../shared/components/form-field/UploadFile';

import { reset } from 'redux-form';
import { SubmissionError } from 'redux-form'
import { stopSubmit } from 'redux-form'

import { getCashback, addCashback, updateCashback, resetCashback } from '../../actions/cashbackActions'; 
import { getCategories } from '../../actions/categoryActions';
import { getCountries } from '../../actions/countryActions';
import { getBrands } from '../../actions/brandActions';
import { getBanks } from '../../actions/bankActions';
import { checkAuth } from '../../actions/sessionActions';
import { validate } from './validate';

import './CashbackForm.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// Redux Store
import configureStore from '../../shared/redux/configureStore';
// Configuring Redux Store
const store = configureStore(window.initialState);

const messages = {
  emptyFilterList: 'No results. Try another query'
}

const renderDescription = (name, label) => {
  return (
      <Field
        name={name}
        type="text"
        component={renderTextareaField}
        label={label}
        className="form-control"
        asterisk="*"
      />
    )
}

const renderTitle = (name, label) => {
  return (
      <Field
        name={name}
        type="text"
        component={renderField}
        label={label}
        className="form-control"
        asterisk="*"
      />
  )
}

const renderTerms = (name, label) => {
  return (
      <Field
        name={name}
        type="text"
        component={renderTextareaField}
        label={label}
        className="form-control"
        asterisk="*"
      />
  )
}

class CashbackForm extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      open: false,
      create: false,
      categories: null,
      countries: null,
      brands: null,
      selectedBrand: '',
      selectedUnit: '',
      brandSearchResult: null,
      countrySearchResult: null,
      categorySearchResult: null,
      bankSearchResult: null,
      targeted: null,
      offline: null
    }
    this.submit = this.submit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUnitChange = this.handleUnitChange.bind(this);
    this.handleBrandChange = this.handleBrandChange.bind(this);
    this.handleBrandSearch = this.handleBrandSearch.bind(this);
    this.handleCountrySearch = this.handleCountrySearch.bind(this);
    this.handleCategorySearch = this.handleCategorySearch.bind(this);
    this.handleBankSearch = this.handleBankSearch.bind(this);
    this.handleTargetedChange = this.handleTargetedChange.bind(this);
    this.handleOfflineChange = this.handleOfflineChange.bind(this);
  }
  
  componentDidMount(props) {
    console.log('componentDidMount');
    console.log(props);
    const {getCashback, addCashback, updateCashback, getCategories, getCountries, getBrands, getBanks } = this.props;
    if(this.state.id) {
      getCashback(this.state.id);    
    }
    else {
      this.setState({targeted: false});
    }
    getCategories();
    getCountries();
    getBrands();
    getBanks();
  }
  
  componentDidUpdate(prevProps) {
    console.log('componentDidUpdate')
    console.log(this.props);
    if(!this.props.match.params.id) {
      if(!this.state.create) {
        //this.props.dispatch(reset('cashbackForm'));  // requires form name
        this.props.initialize();
        store.dispatch(resetCashback());
        this.setState({create: true});
        this.setState({categories: null});
        this.setState({countries: null});
        this.setState({brands: null});
        this.setState({banks: null});
      }
    }
    if(this.props.match.params.id) {
      if(this.state.categories==null && typeof(this.props.cashback)!='undefined') {
        this.setState({categories: this.props.cashback.categories.map(item=>item.id)});
        this.props.change('categories', this.props.cashback.categories.map(category => ({ id: category.id, name: category.name.en }))); 
      }
      if(this.state.countries==null && typeof(this.props.cashback)!='undefined') {
        this.setState({countries: this.props.cashback.countries.map(item=>item.code)});
        this.props.change('countries', this.props.cashback.countries.map(country => ({ code: country.code, name: country.name.en }))); 
      }
      if(this.state.brands==null && typeof(this.props.cashback)!='undefined') {
        this.setState({brands: this.props.cashback.brands.map(item=>item.id)});
        this.props.change('brands', this.props.cashback.brands.map(brand => ({ id: brand.id, name: brand.name }))); 
      }
      if(this.state.banks==null && typeof(this.props.cashback)!='undefined') {
        this.setState({banks: this.props.cashback.banks.map(item=>item.id)});
        this.props.change('banks', this.props.cashback.banks.map(bank => ({ id: bank.id, name: bank.name }))); 
      }

    }
  }

  // Save Cashback
  submit(values) {

    var action;

    if(typeof(values.active)=='undefined') {
      values.active = false;
    }

    if(values.categories!=null && values.categories.length>0) {
      values.category_ids = values.categories.map(item=>item.id)
    }
    else {
      values.category_ids = [null];
    }
    
    if(values.countries!=null && values.countries.length>0) {
      values.country_codes = values.countries.map(item=>item.code)
    }
    else {
      values.country_codes = [null];
    }

    if(values.brands!=null && values.brands.length>0) {
      values.brand_ids = values.brands.map(item=>item.id)
    }
    else {
      values.brand_ids = [null];
    }

    if(this.state.banks!=null && values.banks.length>0) {
      values.bank_ids = values.banks.map(item=>item.id)
    }
    else {
      values.bank_ids = [null];
    }

    if(this.state.selectedBrand!=null) {
      values.brand_id = values.brand.id;
    }
    else {
      values.brand_id = null;
    }

    if(this.state.create) {
      action = addCashback(values);
    }
    else {
      action = updateCashback(values);
    }
    store.dispatch(action).then((result) => {
      if(typeof(result)!='undefined') {
        this.setState({open: true});
      }
  	}).catch((error) => {
  		throw new SubmissionError({_error:  error });
  	});	
  }
  
  handleClose() {
    this.setState({open: false});
  }

  handleUnitChange(e) {
    this.setState({selectedUnit: e=='' ? null : e});
  }

  handleBrandChange(e) {
    this.setState({selectedBrand: e=='' ? null : e});
    if(typeof(e.id)=='undefined') {
      this.handleBrandSearch(e);
    }
  }

  handleBrandSearch = debounce((searchTerms) => {
    this.brandSearch(searchTerms);
  }, 500);

  brandSearch(searchTerms) {
    console.log('handleBrandSearch');
    var params = {}
    var search = {}
    search['search[name]'] = encodeURIComponent(searchTerms.trim());
    Object.assign(params, search);
    store.dispatch(getBrands(params)).then((result) => {
      var brandSearchResult = result.payload.items.map(brand => ({ id: brand.id, name: brand.name }));
      this.setState({brandSearchResult: brandSearchResult});
    }).catch((error) => {
      //throw new SubmissionError({_error:  error });
      this.setState({
        error: error,
        modalOpen: true
      });
    }); 
  }

  handleCountrySearch = debounce((searchTerms) => {
    this.countrySearch(searchTerms);
  }, 500);

  countrySearch(searchTerms) {
    console.log('handleCountrySearch');
    var params = {}
    var search = {}
    search['search[name]'] = encodeURIComponent(searchTerms.trim());
    Object.assign(params, search);
    store.dispatch(getCountries(params)).then((result) => {
      var countrySearchResult = result.payload.items.map(country => ({ code: country.code, name: country.name.en }));
      this.setState({countrySearchResult: countrySearchResult});
    }).catch((error) => {
      //throw new SubmissionError({_error:  error });
      this.setState({
        error: error,
        modalOpen: true
      });
    }); 
  }

  handleCategorySearch = debounce((searchTerms) => {
    this.categorySearch(searchTerms);
  }, 500);

  categorySearch(searchTerms) {
    console.log('handleCategorySearch');
    var params = {}
    var search = {}
    search['search[name]'] = encodeURIComponent(searchTerms.trim());
    Object.assign(params, search);
    store.dispatch(getCategories(params)).then((result) => {
      var categorySearchResult = result.payload.items.map(category => ({ id: category.id, name: category.name.en }));
      this.setState({categorySearchResult: categorySearchResult});
    }).catch((error) => {
      //throw new SubmissionError({_error:  error });
      this.setState({
        error: error,
        modalOpen: true
      });
    }); 
  }

  handleBankSearch = debounce((searchTerms) => {
    this.bankSearch(searchTerms);
  }, 500);

  bankSearch(searchTerms) {
    console.log('handleBankSearch');
    var params = {}
    var search = {}
    search['search[name]'] = encodeURIComponent(searchTerms.trim());
    Object.assign(params, search);
    store.dispatch(getBanks(params)).then((result) => {
      var bankSearchResult = result.payload.items.map(bank => ({ id: bank.id, name: bank.name }));
      this.setState({bankSearchResult: bankSearchResult});
    }).catch((error) => {
      //throw new SubmissionError({_error:  error });
      this.setState({
        error: error,
        modalOpen: true
      });
    }); 
  }

  handleTargetedChange(e) {
    this.setState({targeted: e.target.checked});
  }

  handleOfflineChange(e) {
    this.setState({offline: e.target.checked});
  }
   
  render() {
    
    const session = this.props.session
    if(typeof(session.forceLogout)!="undefined" && session.forceLogout==1) {
      this.setState({session: null});
      window.location.href="/login";
    }
           
    const { error, handleSubmit, pristine, reset, submitting, message, categories, countries, brands, banks, cashback } = this.props

    console.log('---render')
    var targeted = false;
    if(this.state.targeted==null && typeof(cashback)=='undefined') {
      targeted = false;
    }
    else if(this.state.targeted==null && typeof(cashback)!='undefined') {
      targeted = cashback.targeted ? true : false;
    }
    else {
      targeted = this.state.targeted;
    }
    console.log('---targeted');
    console.log(targeted);


    var offline = false;
    if(this.state.offline==null && typeof(offline)=='undefined') {
      offline = false;
    }
    else if(this.state.offline==null && typeof(cashback)!='undefined') {
      offline = cashback.offline ? true : false;
    }
    else {
      offline = this.state.offline;
    }
    console.log('---offline');
    console.log(offline);

    var selectedBrand = '';
    var selectedUnit = '';
    if(typeof(cashback)!='undefined') {
      selectedBrand = cashback.brand.id;
      selectedUnit = cashback.unit;
    }
    if(this.state.selectedBrand==null) {
      selectedBrand = '';
    }
    else if(this.state.selectedBrand!='') {  
      selectedBrand = this.state.selectedBrand;
    }
    if(this.state.selectedUnit==null) {
      selectedUnit = '';
    }
    else if(this.state.selectedUnit!='') {
      selectedUnit = this.state.selectedUnit;
    }
    
    var categoriesArr = categories.map(category => ({ id: category.id, name: category.name.en }));
    if(this.state.categorySearchResult!=null) {
      categoriesArr = this.state.categorySearchResult;
    }
    if(typeof(cashback)!='undefined' && typeof(cashback.categories)!='undefined' && cashback.categories!=null) {
      var cashbackCategories =  cashback.categories;
      for(var i=0; i<cashbackCategories.length; i++) {
        var category = cashbackCategories[i];
        const found = categoriesArr.some(item => item.id === category.id);
        if(!found) {
          categoriesArr = categoriesArr.concat({id: category.id, name: category.name.en});
        }
      }
    }
    categoriesArr = categoriesArr.concat({id: 0, name: '...'});
    
    var countriesArr = countries.map(country => ({ code: country.code, name: country.name.en }));
    if(this.state.countrySearchResult!=null) {
      countriesArr = this.state.countrySearchResult;
    }
    if(typeof(cashback)!='undefined' && typeof(cashback.countries)!='undefined' && cashback.countries!=null) {
      var cashbackCountries =  cashback.countries;
      for(var i=0; i<cashbackCountries.length; i++) {
        var country = cashbackCountries[i];
        const found = countriesArr.some(item => item.id === country.id);
        if(!found) {
          countriesArr = countriesArr.concat({code: country.code, name: country.name.en});
        }
      }
    }
    countriesArr = countriesArr.concat({code: '', name: '...'});

    var brandsArr = brands.map(brand => ({ id: brand.id, name: brand.name }));
    if(this.state.brandSearchResult!=null) {
      brandsArr = this.state.brandSearchResult;
    }
    if(typeof(cashback)!='undefined' && typeof(cashback.brands)!='undefined' && cashback.brands!=null) {
      var cashbackBrands =  cashback.brands;
      for(var i=0; i<cashbackBrands.length; i++) {
        var brand = cashbackBrands[i];
        const found = brandsArr.some(item => item.id === brand.id);
        if(!found) {
          brandsArr = brandsArr.concat({id: brand.id, name: brand.name});
        }
      }
    }
    brandsArr = brandsArr.concat({id: 0, name: '...'});
    
    var banksArr = banks.map(bank => ({ id: bank.id, name: bank.name }));
    if(this.state.bankSearchResult!=null) {
      banksArr = this.state.bankSearchResult;
    }
    if(typeof(cashback)!='undefined' && typeof(cashback.banks)!='undefined' && cashback.banks!=null) {
      var cashbackBanks =  cashback.banks;
      for(var i=0; i<cashbackBanks.length; i++) {
        var bank =  cashbackBanks[i];
        const found = banksArr.some(item => item.id === bank.id);
        if(!found) {
          banksArr =  banksArr.concat({id: bank.id, name: bank.name});
        }
      }
    }
    banksArr = banksArr.concat({id: 0, name: '...'});

    var brandsSingleSelectArr = brands.map(brand => ({ value: brand.id, text: brand.name }));

    return (
      <div className="animated fadeIn mt-5 form-sections">
        <h1 className="h3 text-uppercase">Cashback</h1>
        <form onSubmit={handleSubmit(this.submit)}>
          <Row>
            <Col xs="12" lg="6">
                <Card>
                  <CardBody>
                    <Card>
                      <CardBody>
                      <CardTitle className="d-inline">Offer</CardTitle>
                        <Field name="targeted" component={renderCheckbox} color="primary" label="Targeted" onChange={(event)=>this.handleTargetedChange(event)} />
                        <Row>
                          <Col xs="12">
                            <Field
                              name="website"
                              type="text"
                              component={renderField}
                              label="Website"
                              className="form-control"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12">
                            <div className="d-block d-sm-flex align-items-center">
                              <Label className="mr-3 pb-1">Valid</Label>
                              <Field name="online" component={renderCheckbox} color="primary" label="Online" />
                              <Field name="offline" component={renderCheckbox} color="primary" label="Offiline" onChange={(event)=>this.handleOfflineChange(event)} />
                            </div>
                          </Col>
                        </Row>
                        <Field
                          name="brand"
                          type="select"
                          component={renderCombobox}
                          label="Brand - type to search Brand e.g. Adidas"
                          data={brandsArr}
                          defaultValue={selectedBrand}
                          valueField="id"
                          textField="name"
                          filter={true}
                          className="p-0 pr-2"
                          onChange={(event) => this.handleBrandChange(event)}
                          disabled={[{id:0, name: '...'}]}
                          asterisk="*"
                        />
                        <Row className="mt-3 mb-3 translations">
                          <Col xs="12" className="pr-4">
                            <Tabs tabs={[{label: 'EN', items: [renderTitle('title.en', 'Title'), renderDescription('description.en', 'Description'), renderTerms('terms.en', 'Terms')]}, {label: 'DE', items: [renderTitle('title.de', 'Title'), renderDescription('description.de', 'Description'), renderTerms('terms.en', 'Terms')]} ]} />
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col xs="12" lg="12">
                            <Label>Logo</Label><br />
                            <Field component={UploadFile} name='logo' accept='.jpg, .png' className="mb-3" />
                            {typeof(cashback)!='undefined' && cashback.logo!=null && !this.state.create &&
                              <img src={cashback.logo} className="img-thumbnail brnd-logo d-block" />
                            }
                          </Col> 
                          <Col xs="12" lg="12">
                            <br />
                            <Label>Logo 2x</Label><br />
                            <Field component={UploadFile} name='logo_2x' accept='.jpg, .png' className="mb-3" />
                             {typeof(cashback)!='undefined' && cashback.logo_2x!=null && !this.state.create &&
                              <img src={cashback.logo_2x} className="img-thumbnail brnd-logo d-block" />
                            }
                          </Col>
                        </Row>
                        <Field name="featured" component={renderCheckbox} color="primary" label="Featured. Appears ot top of lists." />
                        <Row>
                          <Col xs="6">
                            <Field
                              name="start_date"
                              type="date"
                              component={renderDateField}
                              label="Start date"
                              className="form-control"
                            />
                          </Col>
                          <Col xs="6">
                            <Field
                              name="end_date"
                              type="date"
                              component={renderDateField}
                              label="End date"
                              className="form-control"
                            />
                          </Col>
                        </Row>
                        <br /><br />
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <CardTitle className="d-inline">Cashback Fields</CardTitle>
                        {!offline &&
                          <Row>
                            <Col xs="12" lg="6">
                             <Field
                                name="identifier"
                                type="text"
                                component={renderField}
                                label="Identifier"
                                className="form-control"
                                asterisk="*"
                              />
                            </Col>
                          </Row>
                        }
                        {!offline &&
                          <Field
                            name="url"
                            type="text"
                            component={renderField}
                            label="URL"
                            className="form-control"
                            asterisk="*"
                          />
                        }
                        <Row>
                          <Col xs="6">
                            <Field
                              name="amount"
                              type="text"
                              component={renderField}
                              label="Amount"
                              className="form-control"
                              asterisk="*"
                            />
                          </Col>
                          <Col xs="6">
                            <Field
                              name="unit"
                              type="select"
                              component={renderSelectField}
                              options={[{value: '%', text: '%'}, {value: '€', text: '€'}]}
                              defaultValue={selectedUnit}
                              label="Unit"
                              className="form-control"
                              onChange={(event) => this.handleUnitChange(event.target.value)}
                              asterisk="*"
                            />
                          </Col>
                        </Row>
                        <Field
                          name="commission_fee"
                          type="number"
                          component={renderField}
                          label="Commission fee"
                          className="form-control"
                        />
                        {!offline &&
                          <div className="d-flex mb-4">
                            <Field
                              name="vat"
                              type="number"
                              component={renderField}
                              label="VAT"
                              className="form-control"
                            />
                            <Field
                              name="tolerance"
                              type="number"
                              component={renderField}
                              label="Tolerance"
                              className="form-control"
                            />
                          </div>
                        }
                        {!offline &&
                          <Shipping />
                        }
                      </CardBody>
                    </Card>  
                  </CardBody>
                </Card>
            </Col>
            {targeted &&
            <Col xs="12" lg="6">
                <Card>
                  <CardBody>
                    <Card>
                      <CardBody>
                        <CardTitle>Targeting</CardTitle>
                        <div className="d-flex align-items-center">
                          <div><label className="mb-2 mr-3 MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">Gender</label></div>
                          <Field name="male" component={renderCheckbox} color="primary" label="Male" />
                          <Field name="female" component={renderCheckbox} color="primary" label="Female" />
                        </div>
                        <Row>
                          <Col xs="6">
                            <Field
                              name="start_age"
                              type="number"
                              component={renderField}
                              label="Start age"
                              className="form-control"
                            />
                          </Col>
                          <Col xs="6">
                            <Field
                              name="end_age"
                              type="number"
                              component={renderField}
                              label="End age"
                              className="form-control"
                            />
                          </Col>
                        </Row>
                        <br />
                        <Label>Banks - <em>Leave the field empty if you want the offer to be valid for all Banks.</em></Label>
                        <Field
                          name="banks"
                          component={renderMultiselect}
                          data={banksArr}
                          value={[]}
                          valueField="id"
                          textField="name"
                          filter={false}
                          onSearch={this.handleBankSearch}
                          messages={messages}
                          disabled={[{id:0, name: '...'}]}
                        />
                        <Label className="mt-1">Type to search Banks e.g. DKB</Label>
                        <br /><br />
                        <Label>Countries - <em>Leave the field empty if you want the offer to be valid for all Countries.</em></Label>
                        <Field
                          name="countries"
                          component={renderMultiselect}
                          data={countriesArr}
                          value={[]}
                          valueField="code"
                          textField="name"
                          filter={false}
                          onSearch={this.handleCountrySearch}
                          messages={messages}
                          disabled={[{code:'', name: '...'}]}
                        />
                        <Label className="mt-1">Type to search Country e.g. Germany</Label>
                        <br /><br />
                        <label>Categories - <em>Leave the field empty if you want the offer to be valid for all Categories.</em></label>
                        <Field
                          name="categories"
                          component={renderMultiselect}
                          data={categoriesArr}
                          value={[]}
                          valueField="id"
                          textField="name"
                          filter={false}
                          onSearch={this.handleCategorySearch}
                          messages={messages}
                          disabled={[{code:'', name: '...'}]}
                        />
                        <Label className="mt-1">Type to search Category e.g. Electronics</Label>
                        <br /><br />
                        <Label>Brands - <em>Leave the field empty if you want the offer to be valid for all Brands.</em></Label>
                        <Field
                          name="brands"
                          component={renderMultiselect}
                          data={brandsArr}
                          value={[]}
                          valueField="id"
                          textField="name"
                          filter={false}
                          onSearch={this.handleBrandSearch}
                          messages={messages}
                          disabled={[{id:0, name: '...'}]}
                        />
                        <Label className="mt-1">Type to search Brands e.g. Adidas</Label>
                        <br /><br />
                        <Row>
                          <Col xs="12" lg="6">
                            <Field
                              name="turnover"
                              type="number"
                              component={renderField}
                              label="Min. turnover in the last 6m"
                              className="form-control"
                            />
                            <Field
                              name="payments_count"
                              type="number"
                              component={renderField}
                              label="Min. payments in the last 6m"
                              className="form-control"
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </CardBody>
                </Card>
              </Col>
              }                  
              <Col xs="12">
                {!!error && <div className="form-error mt-3">{error && <strong>{error}</strong>}</div>}
                <div>
                  <Field name="active" component={renderCheckbox} color="primary" label="Active" />
                  <button type="submit" className="btn btn-primary mb-5" disabled={pristine || submitting}>Submit</button>
                </div>
              </Col>
          </Row>
        </form>
        <Snackbar open={this.state.open} autoHideDuration={2000} message="Saved" onClose={() => this.setState({open: false})}
          action={
            <React.Fragment>
              <a className="text-white cursor-pointer mr-2" aria-label="close" onClick={this.handleClose}><i className="cil-x"></i></a>
            </React.Fragment>
          } 
        />
      </div>
    )
  }
}

CashbackForm.propTypes = {
  pristine: PropTypes.bool,
  message: PropTypes.string,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  cashback: PropTypes.object,
  brands: PropTypes.array,
  categories: PropTypes.array,
  countries: PropTypes.array,
  banks: PropTypes.array,
  session: PropTypes.bool
};

function mapStateToProps(state) {
  console.log('STATE');
  console.log(state);
    return {
      //formData: state.cashbacks,
      initialValues: typeof(state.cashbackForm)!=='undefined' ? state.cashbackForm.cashback : null,
      cashback: typeof(state.cashbackForm)!=='undefined' ? state.cashbackForm.cashback : null,
      categories: (typeof(state.categories)!=='undefined' && typeof(state.categories.result)!=='undefined') ? state.categories.result.items : [],
      countries: (typeof(state.countries)!=='undefined' && typeof(state.countries.result)!=='undefined') ? state.countries.result.items : [],
      brands: (typeof(state.brands)!=='undefined' && typeof(state.brands.result)!=='undefined') ? state.brands.result.items : [],
      banks: (typeof(state.banks)!=='undefined' && typeof(state.banks.result)!=='undefined') ? state.banks.result.items : [],
      session: state.session
    }
  };

const mapDispatchToProps = dispatch => bindActionCreators({getCashback, addCashback, updateCashback, resetCashback,  getCategories, getCountries, getBrands, getBanks, checkAuth}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
   form: 'cashbackForm', // a unique identifier for this form,
   enableReinitialize: true,
   validate
})(CashbackForm))